import EventLayout from '@layouts/Event.layout.jsx';

export default function PromoterLayout() {
  return (
    <EventLayout
      showPreloader={true}
      hideButtonsImmediately={true}
      mainButtonParams={{
        isEnabled: false,
        isVisible: false,
      }}
    />
  );
}
